import { ReactNode } from "react";
import { type InlineMessageProps } from "./inline-message";
import { InfoAlt } from "../icons/info-alt";
import { Check } from "../icons/check";
import { WarningAlt } from "../icons/warning-alt";

export function getIconByType(type: InlineMessageProps["type"]): ReactNode {
    if (type === "info") return <InfoAlt />;
    if (type === "success") return <Check />;
    return <WarningAlt />;
}
